// extracted by mini-css-extract-plugin
module.exports = {"scrollText":"scrollText_scrollText__jbef5","text-scroll-v":"scrollText_text-scroll-v__cIcPK"};